import React from 'react'

import { useTable } from 'react-table'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import { TableHeadComponent } from './components/tableHead'
import StatelessTableControls from './components/tableControls'
import { TableBodyComponent } from './components/tableBody'
import TablePagination from './components/tablePagination'
import APILoadingSpinnerRenderer from '../apiLoadingSpinner'
import { TableContainer } from '../../../theme/Table'
import { CustomTableHead } from './styles'
import EmptyTableMessage from '../emptyTableMessage'
import { EMPTY_TABLE_MESSAGE } from '../../../common/enum/emptyTableMessage'

const locationHashList = [
  '#/minWage/notifications',
  '#/paidLeave/notifications'
]

const StatelessDataTable = ({
  isLoading,
  columns,
  data,
  total,
  pageCount,
  showLocaleFilter,
  showPaidLeaveFilter,
  showDateFilter,
  pageNumber,
  filters,
  showSearch,
  showExport,
  showExportDropdown,
  exportOptions,
  filterOptions,
  eventHandlers,
  rowsPerPage,
  recordType,
  stateListFiltered,
  isScrollable,
  isHeaderSticky,
  locales
}) => {
  const componentColumns = React.useMemo(() => columns, [columns])
  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns: componentColumns,
    data
  })

  return (
    <React.Fragment>
      <StatelessTableControls
        total={total}
        filters={filters}
        showLocaleFilter={showLocaleFilter}
        showDateFilter={showDateFilter}
        showPaidLeaveFilter={showPaidLeaveFilter}
        eventHandlers={eventHandlers}
        showSearch={showSearch}
        showExport={showExport}
        showExportDropdown={showExportDropdown}
        exportOptions={exportOptions}
        isLoading={isLoading}
        recordType={recordType || 'Records'}
        stateListFiltered={stateListFiltered}
        filterOptions={filterOptions}
        locales={locales}
      />
      <TableContainer scrollable={isScrollable}>
        <Table {...getTableProps()}>
          <CustomTableHead>
            <TableHeadComponent
              {...{
                headerGroups,
                isLoading,
                columns,
                isScrollable,
                isHeaderSticky
              }}
            />
          </CustomTableHead>
          <TableBody>
            {isLoading ? (
              <APILoadingSpinnerRenderer isTable colspan={columns.length} />
            ) : data.length > 0 ? (
              <TableBodyComponent
                {...{
                  prepareRow,
                  rows,
                  columns,
                  isScrollable
                }}
              />
            )
              : (
                <EmptyTableMessage
                  columns={columns.length}
                  text={locationHashList.includes(location.hash) ? EMPTY_TABLE_MESSAGE.NO_LOCATIONS : EMPTY_TABLE_MESSAGE.NO_RESULTS}
                />
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {!isLoading && total > 10 ? (
        <TablePagination
          rowsPerPage={rowsPerPage}
          recordCount={total}
          pageCount={pageCount}
          recordType={recordType || 'records'}
          currentPage={pageNumber}
          onChangePagination={eventHandlers.handleChangePage}
        />
      ) : null}
    </React.Fragment>
  )
}

export default StatelessDataTable
